import { useAtomValue } from "jotai";

import { PackagesList } from "../../PackagesList";
import { packageListFragmentAtom } from "../atoms";
import { PackageType } from "./__generated__/ModalLoaderQuery.graphql";

type Props = {
  type: PackageType;
};

export const CurrentPackagesList = ({ type }: Props) => {
  const customerRef = useAtomValue(packageListFragmentAtom);

  return <PackagesList type={type} customerRef={customerRef} />;
};
